<template>
  <b-link
    :to="{
      name: `influencer.profile-page`,
      params: {
        id: user.influencer_uid,
        username: user.username,
      },
    }"
  >
    <slot />
  </b-link>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped></style>
